import './thumbnail.css';
import template from './thumbnail.tpl.html';

export const thumbnail = {
    bindings: {
        imagepath: '@',
        evttitle1: '@',
        evttitle2: '@',
        description: '@',
        date: '@',
        pinauth: '@',
        live: '@',
        isfeatured: '@',
        channel: '@',
        directlink: '@',
        channellink: '@',
        imagever: '@'
    },
    template
};
